import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { store } from './app/store';
import { Provider, ReactReduxContext } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import AWS from 'aws-sdk';
import './Style.scss';
import config from './config.json';

// Config aws
AWS.config.region = config.awsRegion; // Region

ReactDOM.render(
  <Provider store={store} context={ReactReduxContext}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
serviceWorker.register({
  // eslint-disable-next-line no-console
  onSuccess: () => console.log('Installed serviceWorker'),
  // eslint-disable-next-line no-console
  onUpdate: () => console.log('Updated service worker, update will be applied when all tabs are closed')
});
